export default __webpack_public_path__ + "static/media/dimg8.4e542fc3.jpg";